import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { ColorNeutralBlack, Spacing8 } from 'autogen/design-tokens/tokens';
import type { MiniBasketSampleLineViewModel } from 'autogen/swagger/all';
import { useRemoveSampleFromBasketMutation } from 'autogen/swagger/all/hooks';
import { Free } from 'autogen/translation-keys/trans-website-basket';
import { ButtonWithIcon } from 'components/Button';
import { updateBasket } from 'components/basket/shared/basket';
import Card from 'components/generic/card';
import ProductImage from 'components/generic/productImage';
import { ProductImageContainer } from 'components/generic/productImage/shared/styles';
import ProductName from 'components/generic/productName';
import Icon from 'components/Icon';
import Flex from 'components/Layout/components/Flex';
import track from 'modules/tracking/dataLayer';
import { breakpoint, sizes } from 'variables';

/* #region styles */
export const Grid = styled.div`
    display: grid;
    gap: ${Spacing8};
    grid-template-columns: auto 64px 1fr;
    align-items: center;

    ${breakpoint.up(sizes.lg)} {
        grid-template-columns: auto 64px 1fr;
    }
`;

const StyledProductName = styled(ProductName)`
    &:first-child {
        font-weight: ${({ theme }) => theme.TypographyBodyWeightDefault};
    }
`;

/* #endregion */

export default function MiniBasketSampleItem({ model }: { model: MiniBasketSampleLineViewModel }) {
    const { productName, primaryImage, productId } = model;
    const { t } = useTranslation();
    const { mutateAsync: removeSampleFromBasket } = useRemoveSampleFromBasketMutation({ onSuccess: updateBasket });

    return (
        <Card size={null}>
            <Card.Content>
                <Grid>
                    <ButtonWithIcon
                        css={css`
                            align-self: center;
                        `}
                        size="sm"
                        variant="ghostOnLight"
                        icon={<Icon type="Close" size={16} />}
                        onClick={() =>
                            removeSampleFromBasket({ params: { productId } }).then((response) => {
                                if (response.dataLayerDto) {
                                    track(response.dataLayerDto);
                                }
                            })
                        }
                    />

                    <ProductImageContainer>
                        <ProductImage width={64} image={primaryImage} transformType="SquareScale" />
                    </ProductImageContainer>

                    <Flex.Row justifyContent="space-between" alignItems="center">
                        <Flex.Column gap={Spacing8}>
                            <StyledProductName
                                productName={productName}
                                size="sm"
                                customTheme={{
                                    ProductTitle: css`
                                        color: ${ColorNeutralBlack};
                                    `
                                }}
                            />
                        </Flex.Column>

                        <Flex.Column alignItems="end">{t(Free)}</Flex.Column>
                    </Flex.Row>
                </Grid>
            </Card.Content>
        </Card>
    );
}
